/* ==========================================================================
   ModalMsi > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const ModalClient = require('@bluekiri/alexandria-contrib-components/components/modal/client/js');
const ImageClient = require('@bluekiri/alexandria-contrib-components/components/image/client/js');
const config = require('./config');

/**
 * ModalMsi component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ModalMsi(
    selector = `[data-component="Modal"][data-type="${config().type.modal}"]`,
    configuration = {}
) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = {};

        /* Element */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = { ...config(), ...configuration };

        /* Images */
        instance.images = [...instance.element.querySelectorAll('[data-component="Image"]')].map((item, index) =>
            ImageClient(`${selector} [data-component="Image"][data-type="${config().type.image}-${index}"]`, {
                ...configuration.image
            })
        );

        /* Modal */
        instance.modal = ModalClient(selector, {
            ...configuration.modal,
            type: config().type.modal
        });

        /* Returns */
        return instance;
    }
};
